define("shared/components/shared/self-describes/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::SelfDescribes::Survey @showContextModal={{this.showContextModal}} />
  
  {{#if this.isContextModalOpen}}
    <Shared::SelfDescribes::ContextModal
      @closeModal={{this.closeContextModal.perform}}
      @closeModalAfterCheckout={{this.closeContextModalAfterCheckout.perform}}
      @currentAccount={{this.currentAccount}}
      @plan={{this.plan}}
      @planType={{this.planType}}
    />
  {{/if}}
  
  {{#if this.shouldShowSocialConnectOnboarding}}
    <Shared::Social::SocialConnectOnboarding @closeModal={{this.closeSocialConnectOnboarding.perform}} />
  {{/if}}
  
  <Shared::CardLessTrial::AutoTrialExpiry />
  */
  {
    "id": "sBSZlJwl",
    "block": "[[[8,[39,0],null,[[\"@showContextModal\"],[[30,0,[\"showContextModal\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"isContextModalOpen\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@closeModal\",\"@closeModalAfterCheckout\",\"@currentAccount\",\"@plan\",\"@planType\"],[[30,0,[\"closeContextModal\",\"perform\"]],[30,0,[\"closeContextModalAfterCheckout\",\"perform\"]],[30,0,[\"currentAccount\"]],[30,0,[\"plan\"]],[30,0,[\"planType\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"shouldShowSocialConnectOnboarding\"]],[[[1,\"  \"],[8,[39,3],null,[[\"@closeModal\"],[[30,0,[\"closeSocialConnectOnboarding\",\"perform\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,4],null,null,null]],[],false,[\"shared/self-describes/survey\",\"if\",\"shared/self-describes/context-modal\",\"shared/social/social-connect-onboarding\",\"shared/card-less-trial/auto-trial-expiry\"]]",
    "moduleName": "shared/components/shared/self-describes/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});